/**
 * Fetch a teaching plan from /documents/teaching-plans/ and add it to
 * the chat composer as a conversation attachment. The composer's
 * ConversationAttachmentAdapter takes care of uploading to Nova OS
 * (POST /v1/conversations/{cid}/attachments) and the chip lifecycle.
 *
 * Shared by:
 *   - the explicit "Attach plan…" picker pill (teacher click)
 *   - the auto-attach heuristic on composer text changes
 */
import { PLANS_PATH, readDocText } from "./documentsApi";

interface ComposerLike {
  addAttachment: (file: File) => Promise<void> | void;
}

export async function attachPlanByFilename(
  composer: ComposerLike,
  filename: string,
): Promise<void> {
  const text = await readDocText(`${PLANS_PATH}/${filename}`);
  // Preserve the plan's filename + markdown mime so the chip renders
  // with the original name and the agent sees a real markdown file
  // rather than a generic blob.
  const file = new File([text], filename, { type: "text/markdown" });
  await composer.addAttachment(file);
}
